//import axios from 'axios';
import axios from '../utils/axios';

const API_URL = process.env.REACT_APP_API_URL + "/v1/admin/";

const getStats = () => {
    return axios.get(API_URL + "/dashboards");
}
const getMoreState = () => {

}
const addUsers = (id, data) => {
    return axios.post(API_URL + "clinics/" + id + "/users", data);
}
const getUsers = (id) => {
    return axios.get(API_URL + "clinics/" + id + "/users");
}
const getUser = (id, uid) => {
    return axios.get(API_URL + "clinics/" + id + "/users/" + uid);
}
const updateUser = (userId, clinicId, data) => {
    return axios
        .put(API_URL + "clinics/" + clinicId + "/users/" + userId, data)
}

const changePassword = (userId, clinicId, passwordChangeData) => {
    return axios.post(API_URL + "clinics/" + clinicId + "/users/" + userId + "/change-password", passwordChangeData)
}

const deleteUser = (userId, clinicId) => {
    return axios
        .delete(API_URL + "clinics/" + clinicId + "/users/" + userId)
}
const getRoles = () => {
    return axios.get(API_URL + "roles");
}
const passwordReset = (clinicId, userId) => {
    return axios.get(API_URL + "clinics/" + clinicId + "/users/" + userId + "/reset-password")
}
const getUserReminderSettings = (clinicId, userId) => {
    return axios
        .get(API_URL + "clinics/" + clinicId + "/users/" + userId + "/reminder-settings")
}
const updateUserReminderSettings = (clinicId, userId, data) => {
    return axios
        .put(API_URL + "clinics/" + clinicId + "/users/" + userId + "/reminder-settings", data)
}
export default {
    addUsers,
    getUsers,
    getUser,
    changePassword,
    updateUser,
    deleteUser,
    getRoles,
    passwordReset,
    getUserReminderSettings,
    updateUserReminderSettings
}